import React, { useState } from "react";
import Wmbutton from "../../ui-components/wm-button/Wm.button";
import { Col } from 'react-bootstrap'
import Required from '../../Components/required/Required';
import WmModals from "../../modals/Wm.Modals";
import "./skills.css";
import NumberRating from "../Rating/NumberRating";

function Skills({ handleAddSkillData }) {
    const [openSkillModal, setOpenSkillModal] = useState(false)
    const [skillData, setSkillData] = useState({ title: '', rate: '' })

    const handleTitle = (value) => {
        setSkillData((skillData) => {
            skillData.title =  value
            return {...skillData}
        })
    }
    return (
        <>
            <Col md={12} className="my-8">
                <div className="mb-3">
                    <Wmbutton className="px-4 rounded" label="Add Skills" type="button" color="primary" onClick={() => setOpenSkillModal(true)} />
                </div>
            </Col>
            <WmModals show={openSkillModal} onHide={() => setOpenSkillModal(false)} size="md" className="">
                <div className="modal--head border-b border-gray-400 border-solid py-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <h4 className="modal-title manpro font-bold text-2xl">Skills</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal--body border-b border-gray-400 border-solid py-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="wm_form_group flex flex-col">
                                    <label className="wm_form_label"> Title <Required /></label>
                                    <input type="text" name="institute" required className="wm_form_input border-bottom border-gray-300" value={skillData.title} onChange={(e) => handleTitle(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className='border rounded mt-3'>
                                    <div className='text-center manpro font-semibold text-xl py-2'>
                                        Range select
                                    </div>
                                    <div className='m-2 py-2 bg-gray-100 rounded-3xl'>
                                        <NumberRating range={5} onSelectRange={(range) => setSkillData(() => {skillData.rate = range; return {...skillData}})} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal--foot py-3">
                    <div className="container-fluid">
                        <div className="row justify-end px-3">
                            <div className="space-x-3">
                                <Wmbutton className="px-4 rounded" label="Add" type="button" color="primary" onClick={() => {handleAddSkillData(skillData);setOpenSkillModal(false);setSkillData({ title: '', rate: '' })}} />
                                <Wmbutton className="px-4 rounded" label="Cancel" bordered type="button" color="primary-border" onClick={() => setOpenSkillModal(false)} />
                            </div>
                        </div>
                    </div>
                </div>
            </WmModals>
        </>
    );
}

export default Skills;
